import React, { Component } from 'react';

import { 
  Input,
  FormGroup, 
  Label,
  Popover,
  PopoverBody 
} from 'reactstrap';

import { injectStripe } from 'react-stripe-elements';

import Form from '../../../shared/components/Form';
import PromoCodeInput from '../../../shared/components/PromoCodeInput';
import CreditCardForm from '../../../shared/components/CreditCardForm';
import BillingInfoForm from '../../../shared/components/BillingInfoForm';
import Button from '../../../shared/components/Button';

import { 
  validationMessagesFromStripeError,
  formatPaymentMethod
} from '../../../shared/utils';

import {
  validateBillingAddress
} from '../../../shared/validators';

const EXISTING_FUNDS_PAYMENT_METHOD = '__EXISTING_FUNDS_PAYMENT_METHOD__',
  DEFAULT_CREDIT_CARD_PAYMENT_METHOD = '__DEFAULT_CREDIT_CARD_PAYMENT_METHOD__',
  ADD_CREDIT_CARD_PAYMENT_METHOD = '__ADD_CREDIT_CARD_PAYMENT_METHOD__';

class CampaignPaymentForm extends Component {
  constructor(props){
    super();

    this.state = {
      validationMessages:{}
    };
  }

  componentWillMount(){
    if(this.props.activePaymentMethodId){
      if(this.props.activePaymentMethodId.length > 0){
        this.setState({activePaymentMethod:DEFAULT_CREDIT_CARD_PAYMENT_METHOD});
      } else {
        this.setState({activePaymentMethod:EXISTING_FUNDS_PAYMENT_METHOD});
      }
      
    } else if(this.props.accountBalance > 0 || this.props.showSuperadminFeatures){
      this.setState({activePaymentMethod:EXISTING_FUNDS_PAYMENT_METHOD});
    } else if(this.props.defaultPaymentMethodId){
      this.setState({activePaymentMethod:DEFAULT_CREDIT_CARD_PAYMENT_METHOD});
    }else {
      this.setState({activePaymentMethod:ADD_CREDIT_CARD_PAYMENT_METHOD});
    }
  }

  handleSubmit(data){
    if(this.state.activePaymentMethod === ADD_CREDIT_CARD_PAYMENT_METHOD){
      const billingAddressValidationMessages = validateBillingAddress(data);

      if(Object.keys(billingAddressValidationMessages).length > 0){
        this.setState({validationMessages:billingAddressValidationMessages});
        return;

      } else {
        this.props.stripe.createToken({
          name:data.name,
          address_line1:data.address_line1,
          address_line2:data.address_line2,
          address_city:data.address_city,
          address_state:data.address_state,
          address_zip:data.address_zip,
          country:'US',
          currency:'usd'
        })
          .then((res) => {
            if(res.error){ 
              this.setState({validationMessages:validationMessagesFromStripeError(res.error)});
              return;
            } else if(!res.token){
              throw new Error('No token from Stripe');
              return;
            } else {
              this.props.onStripeTokenSubmit(res.token);
              return;
            }
          });
      } 
    } else if(this.state.activePaymentMethod === DEFAULT_CREDIT_CARD_PAYMENT_METHOD){
      this.props.onDefaultCreditCardSubmit();
    } else {
      this.props.onExistingFundsSubmit();
    }
  }


  render(){
    return (
      <div className='PaymentForm CampaignPaymentForm'>
        <Form onSubmit={(data) => this.handleSubmit(data)}>
          <FormGroup>
            <span></span>
            <Input 
              type='select' 
              value={this.state.activePaymentMethod} 
              onChange={(e) => this.setState({activePaymentMethod:e.target.value})}
            >
              {(this.props.accountBalance || this.props.showSuperadminFeatures) && (
                <option value={EXISTING_FUNDS_PAYMENT_METHOD}>
                  Existing Funds: ${(this.props.accountBalance || 0).toLocaleString()}
                </option>
              )}
              {!this.props.showSuperadminFeatures && (
                this.props.defaultPaymentMethodId ? (
                  <option value={DEFAULT_CREDIT_CARD_PAYMENT_METHOD}>
                    Default Credit Card
                  </option>
                ) : (
                  <option value={ADD_CREDIT_CARD_PAYMENT_METHOD}>
                    New Credit Card
                  </option>
                )
              )}
            </Input>
          </FormGroup>
          {this.state.activePaymentMethod === ADD_CREDIT_CARD_PAYMENT_METHOD && (
            <div>
              <h6>Card Info</h6>
              <CreditCardForm validationMessages={this.state.validationMessages} />
              <h6>Billing Name & Address</h6>
              <BillingInfoForm validationMessages={this.state.validationMessages}/> 
            </div>
          )}
          <Button isSubmit>Save</Button>
        </Form>
      </div>
    )
  }
}

const CampaignPaymentFormWithStripe = injectStripe(CampaignPaymentForm);

export default CampaignPaymentFormWithStripe;


// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignReview/components/CampaignPaymentForm.js